import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-employment',
  templateUrl: './employment.component.html',
  styleUrls: ['./employment.component.css']
})
export class EmploymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
